module.exports = __webpack_public_path__ + "img/img4.f553aaf9.jpg";